/**
 * Utility for accessing environment variables
 * Build-time only via Vite (import.meta.env)
 */

// Get the API base URL
export const getApiBaseUrl = (): string => {
  return import.meta.env.VITE_API_BASE || ''
}

/** VITE_RELEASE fallback for unbaked (local dev) builds where the commit SHA isn't injected. */
export const UNKNOWN_RELEASE = 'unknown'

/** The release SHA baked into this bundle at build time, or UNKNOWN_RELEASE in local dev. */
export const getRelease = (): string => import.meta.env.VITE_RELEASE ?? UNKNOWN_RELEASE

/** True except in a production build. Read per call, so a test that flips `VITE_ENV` sees it. */
export const isNonProduction = (): boolean => import.meta.env.VITE_ENV !== 'production'

/** Build default for the in-call key-moments UI; a stored value in `keyMomentsShownService` overrides it. */
export const isInCallKeyMomentsEnabledByDefault = (): boolean =>
  import.meta.env.VITE_ENABLE_IN_CALL_KEY_MOMENTS === 'true'
